// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"e5d7cd9a","193":"e5d7cd9a","818":"e5d7cd9a"}[chunkId] + ".chunk.css";
};